import { gql } from '@apollo/client';

export const GET_DRIVER_IS_NOT_READ_COUNT = gql`
    query GetDriverIsNotReadCount($driverId: Long!) {
        getDriverIsNotReadCount(driverId: $driverId)
    }
`;

export interface GetDriverIsNotReadCountResponse {
    getDriverIsNotReadCount: number;
}

export interface GetDriverIsNotReadCountVariables {
    driverId: number;
}